import {Component, HostBinding, OnInit} from '@angular/core';
import {OverlayContainer} from '@angular/cdk/overlay';
import {NavigationError, Router, RouterModule} from '@angular/router';
import {TopNavComponent} from './top-nav.component';
import {BehaviorSubject, map} from 'rxjs';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {VersionReloadComponent} from './version-reload.component';
import {filter} from 'rxjs/operators';
import {CanaryComponent} from './common/canary.component';
import {AppState} from './common/app-state';
import {OidcSecurityService} from 'angular-auth-oidc-client';

const DARK_MODE_CLASS = 'dark-mode';

@Component({
  selector: 'app-root',
  template: `
      <div [class.hide]="!(loader.value$|async)" class="loader-spinner">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
      <app-top-nav></app-top-nav>
      <div class="app-container">
          <router-outlet></router-outlet>
      </div>
      <version-reload></version-reload>
      <app-canary></app-canary>
  `,
  imports: [
    CommonModule, RouterModule, TopNavComponent, MatProgressSpinnerModule, VersionReloadComponent, CanaryComponent
  ]
})
export class AppComponent implements OnInit {
  @HostBinding('class') className = '';
  darkmode = new BehaviorSubject(false);

  constructor(private overlay: OverlayContainer, public loader: LoadingBarService, private router: Router,
              public appState: AppState, private oidcService: OidcSecurityService) {
  }

  ngOnInit(): void {
    // Handle OIDC callback and redirect to stored URL
    this.oidcService.checkAuth().subscribe(({isAuthenticated}) => {
      if (isAuthenticated) {
        const returnUrl = sessionStorage.getItem('returnUrl');
        if (returnUrl) {
          sessionStorage.removeItem('returnUrl');
          this.router.navigate([returnUrl]);
        }
      }
    });

    this.router.events
      .pipe(
        filter(evt => evt instanceof NavigationError && evt.error instanceof Error && evt.error.name == 'ChunkLoadError'),
        map(evt => evt as NavigationError),
      )
      .subscribe(evt => window.location.assign(evt.url));

    this.darkmode.subscribe((darkMode) => {
      this.className = darkMode ? DARK_MODE_CLASS : '';
      if (darkMode) {
        this.overlay.getContainerElement().classList.add(DARK_MODE_CLASS);
      } else {
        this.overlay.getContainerElement().classList.remove(DARK_MODE_CLASS);
      }
    });

    const {hostname, pathname} = window.location;
    if (hostname !== 'localhost' && pathname !== '/help') {
      const node = document.createElement('script');
      node.src = '//js.hs-scripts.com/144551991.js';
      node.async = true;
      node.id = 'hs-script-loader';
      node.defer = true;
      document.body.appendChild(node);
    }
  }
}
